import React from 'react'
import Image from './Image'
import { FLAGS } from '../constants/'

const flag_style = { width: '21px', marginTop: '-2px' }

const Flag = React.memo(function Flag(props) {
    const { locale, alt = locale || '', className = '' } = props
    return <Image src={FLAGS[locale]} alt={alt} style={flag_style} className={className} />
})

export default Flag
